export const reduxKey = '@@compliantLocalStorage';
export var CompliantLocalStorageKeys;
(function(CompliantLocalStorageKeys) {
    CompliantLocalStorageKeys["RECENT_COLORS"] = 'custombox.recent.colors';
    CompliantLocalStorageKeys["INTENTS"] = 'intents';
    CompliantLocalStorageKeys["INTENTS_OTHER"] = 'intents_other';
    CompliantLocalStorageKeys["STATUS_SUBMIT_COUNTER"] = 'statusUpdateSubmitCounter';
    CompliantLocalStorageKeys["FEDOPS_SESSIONID"] = 'fedops.logger.sessionId';
    CompliantLocalStorageKeys["CHATDB"] = 'chatDB';
    CompliantLocalStorageKeys["EDITOR_DRAFTS"] = 'editorDrafts';
    CompliantLocalStorageKeys["NC_DELETE_ON_REPLY"] = 'ncDeleteOnReply';
    CompliantLocalStorageKeys["DO_NOT_SHOW_AGAIN"] = 'confirm.modal.do.not.show';
    CompliantLocalStorageKeys["SOCIAL"] = 'social';
})(CompliantLocalStorageKeys || (CompliantLocalStorageKeys = {}));
export var CompliantCategories;
(function(CompliantCategories) {
    CompliantCategories["ESSENTIAL"] = 'essential';
    CompliantCategories["FUNCTIONAL"] = 'functional';
    CompliantCategories["MARKETING"] = 'marketing';
    CompliantCategories["ANALYTICS"] = 'analytics';
})(CompliantCategories || (CompliantCategories = {}));
export const LocalStorageCategoryTypeConfig = {
    // essential
    [CompliantLocalStorageKeys.INTENTS]: CompliantCategories.ESSENTIAL,
    [CompliantLocalStorageKeys.INTENTS_OTHER]: CompliantCategories.ESSENTIAL,
    [CompliantLocalStorageKeys.CHATDB]: CompliantCategories.ESSENTIAL,
    [CompliantLocalStorageKeys.FEDOPS_SESSIONID]: CompliantCategories.ESSENTIAL,
    [CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN]: CompliantCategories.ESSENTIAL,
    [CompliantLocalStorageKeys.SOCIAL]: CompliantCategories.ESSENTIAL,
    // functional
    [CompliantLocalStorageKeys.RECENT_COLORS]: CompliantCategories.FUNCTIONAL,
    [CompliantLocalStorageKeys.STATUS_SUBMIT_COUNTER]: CompliantCategories.FUNCTIONAL,
    [CompliantLocalStorageKeys.EDITOR_DRAFTS]: CompliantCategories.FUNCTIONAL,
    [CompliantLocalStorageKeys.NC_DELETE_ON_REPLY]: CompliantCategories.FUNCTIONAL
};
